<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: null,
                    },
                ]"
            >
                <template v-slot:corner>
                    <div>
                        <BadgePill>
                            <InertiaLink :href="meta.links.group_stats">{{ $t('messages.graphs') }}</InertiaLink>
                        </BadgePill>
                    </div>
                </template>
            </SmartBreadcrumbs>
        </template>

        <GroupSelector :grade-levels="gradeLevels" :user-grade-levels="user_grade_levels">
            <template v-slot:default="{ filteredGradeLevels }">
                <div class="mb-2 flex gap-x-2 items-end" v-for="gradeLevel in filteredGradeLevels" :key="gradeLevel.id">
                    <div v-for="group in gradeLevel.groups" :key="group.id">
                        <div v-if="group.image_path">
                            <img class="w-12 h-12 object-contain mb-1" :src="group.image_path" alt="" />
                        </div>
                        <AppButton element="inertia-link" :href="group.url" desired-action class="">
                            {{ group.name }}
                        </AppButton>
                    </div>
                </div>
            </template>
        </GroupSelector>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import GroupSelector from '@/components/GroupSelector.vue';
import AppButton from '@/components/AppButton.vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    components: {
        PanelPage,
        GroupSelector,
        AppButton,
        BadgePill,
    },
    layout: Layout,
    name: 'Show',
    props: ['gradeLevels', 'user_grade_levels', 'meta'],
};
</script>
